import type { TenantAuthConfigResponse } from '@lms/shared'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useTenantAuthConfig(slug: string) {
  return useQuery<TenantAuthConfigResponse>({
    queryKey: ['tenant-auth-config', slug],
    queryFn: () => api.get(`/api/auth/tenant-config/${slug}`),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000, // 5 min — auth config changes rarely
  })
}
